import { initInfrastructure, addEventListeners } from './infrastructure'
import "./index.css"

function orquestrate() {
  initInfrastructure()
  addEventListeners()
}
orquestrate()
